export default import.meta.ROLLDOWN_FILE_URL_MRkRUhlhqYk6wXjZrGkzSA